import { useMantineTheme, Button } from '@mantine/core';
import { IconFilePlus } from '@tabler/icons-react';

type UploadPillButtonProps = {
  loading?: boolean;
  onFilesSelected: (event: React.ChangeEvent<HTMLInputElement>) => void;
  label?: string;
  multiple?: boolean;
  accept?: string;
  disabled?: boolean;
};

export function UploadPillButton({
  loading,
  onFilesSelected,
  label = 'Upload documents or recordings',
  multiple = true,
  accept,
  disabled,
}: UploadPillButtonProps) {
  const theme = useMantineTheme();

  return (
    <Button
      component="label"
      radius="xl"
      leftSection={<IconFilePlus size={24} />}
      loading={loading}
      disabled={disabled}
      style={{
        backgroundColor: theme.colors.orange[1],
        color: theme.colors.orange[7],
        fontWeight: 500,
      }}
      styles={{
        root: {
          height: 'auto',
          paddingLeft: theme.spacing.sm,
          paddingRight: theme.spacing.sm,
        },
        label: {
          whiteSpace: 'normal',
          overflow: 'visible',
          color: theme.colors.brand[7],
          paddingTop: 10,
          paddingBottom: 10,
        },
        section: {
          color: theme.colors.brand[7],
        },
      }}
    >
      {label}

      <input
        type="file"
        multiple={multiple}
        accept={accept}
        style={{ display: 'none' }}
        onChange={onFilesSelected}
      />
    </Button>
  );
}
